(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('menuBtn');
  const drawer = document.getElementById('menuDrawer');
  const close = document.getElementById('closeDrawer');

  btn.addEventListener('click', () => {
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  close.addEventListener('click', () => {
    drawer.classList.remove('active');
    document.body.style.overflow = 'auto';
  });
});

  } catch(e) { console.error(e); }
})();
})();
